import React from 'react';
import StockConfiguration from './components/StockConfiguration/StockConfiguration';
import DietaryAndIngredientsConfig from './components/DietaryConfig/DietaryConfig';
import { ItemStock } from '../../../../../../../../types';

interface IngredientSelection {
    id: number | string; // Allow string for new, unsaved items
    name: string;
    units: number | null;
    unidad_medida_id: number;
}


interface AvancedInfoSectionProps {
  vegano: boolean;
  setVegano: (val: boolean) => void;
  sodio: boolean;
  setSodio: (val: boolean) => void;
  lactosa: boolean;
  setLactosa: (val: boolean) => void;
  azucar: boolean;
  setAzucar: (val: boolean) => void;
  alcohol: boolean;
  setAlcohol: (val: boolean) => void;
  vegetariano: boolean;
  setVegetariano: (val: boolean) => void;
  picante: boolean;
  setPicante: (val: boolean) => void;
  gluten: boolean;
  setGluten: (val: boolean) => void;
  unidadesMedida: { id: number; name: string }[];
  isStock?: boolean;
  setIsStock?: (val: boolean) => void;
  currentStock?: string;
  setCurrentStock?: (val: string) => void;
  minQuantity?: string;
  setMinQuantity?: (val: string) => void;
  unidadMedidaId?: number;
  setUnidadMedidaId?: (val: number) => void;
  selectedUnidadName?: string;
  setSelectedUnidadName?: (val: string) => void;
  ingredientSelections?: IngredientSelection[];
  setIngredientSelections?: React.Dispatch<React.SetStateAction<IngredientSelection[]>>;
  selectedStorageUnit?: any;
  setSelectedStorageUnit?: (val: any) => void;
  storageUnits?: any[];
  setStorageUnits?: (val: any[]) => void;
  stockManagementMode?: 'item' | 'ingredients' | null;
  setStockManagementMode?: (val: 'item' | 'ingredients' | null) => void;
  isComboGroup?: boolean; // NEW: is_combo_group field
  setIsComboGroup?: (val: boolean) => void; // NEW: setter for is_combo_group
  currentItemId?: number | string; // NEW: for update mode detection
  wasStockControlEnabled?: boolean; // NEW: whether stock was enabled when modal opened
  itemStocks?: ItemStock[]; // NEW: for displaying item stocks
  setItemStocks?: (stocks: ItemStock[]) => void; // NEW: for updating item stocks
  localId?: number; // NEW: Local ID for feature flags
  onValidationChange?: (isValid: boolean) => void;
}


const AdvanceInfoSection: React.FC<AvancedInfoSectionProps> = ({ 
   vegano,
   setVegano,
   sodio,
   setSodio,
   lactosa,
   setLactosa,
   azucar,
   setAzucar,
   alcohol,
   setAlcohol,
   vegetariano,
   setVegetariano,
   picante,
   setPicante,
   gluten,
   setGluten,
   unidadesMedida,
   isStock = false,
   setIsStock = () => {},
   currentStock = '',
   setCurrentStock = () => {},
   minQuantity = '',
   setMinQuantity = () => {},
  setUnidadMedidaId = () => {},
  unidadMedidaId = 0,
   selectedUnidadName = 'Seleccionar unidad',
   setSelectedUnidadName = () => {},
   ingredientSelections = [],
   setIngredientSelections = () => {},
   selectedStorageUnit = null,
   setSelectedStorageUnit = () => {},
   storageUnits = [],
   setStorageUnits = () => {},
   stockManagementMode = null,
   setStockManagementMode = () => {},
   isComboGroup = false, // NEW: default value for is_combo_group
   setIsComboGroup = () => {}, // NEW: default setter for is_combo_group
   currentItemId, // NEW: for update mode detection
   wasStockControlEnabled = false, // NEW: whether stock was enabled when modal opened
   itemStocks = [], // NEW: for displaying item stocks
  setItemStocks = () => {}, // NEW: for updating item stocks
  localId = 1,
  onValidationChange = () => {},
}) => {

  return (
    <>
      {/* Stock Configuration - now self-contained */}
      <StockConfiguration
        isStock={isStock}
        setIsStock={setIsStock}
        unidadesMedida={unidadesMedida}
        setUnidadMedidaId={setUnidadMedidaId}
        unidadMedidaId={unidadMedidaId}
        selectedUnidadName={selectedUnidadName}
        setSelectedUnidadName={setSelectedUnidadName}
        currentStock={currentStock}
        setCurrentStock={setCurrentStock}
        minQuantity={minQuantity}
        setMinQuantity={setMinQuantity}
        storageUnits={storageUnits}
        selectedStorageUnit={selectedStorageUnit}
        setSelectedStorageUnit={setSelectedStorageUnit}
        ingredientSelections={ingredientSelections}
        setIngredientSelections={setIngredientSelections}
        stockManagementMode={stockManagementMode}
        setStockManagementMode={setStockManagementMode}
        isComboGroup={isComboGroup}
        setIsComboGroup={setIsComboGroup}
        currentItemId={currentItemId}
        wasStockControlEnabled={wasStockControlEnabled}
        itemStocks={itemStocks}
        setItemStocks={setItemStocks}
        localId={localId}
        onValidationChange={onValidationChange}
      />

      {/* Dietary information */}
      <DietaryAndIngredientsConfig
        gluten={gluten}
        setGluten={setGluten}
        vegano={vegano}
        setVegano={setVegano}
        sodio={sodio}
        setSodio={setSodio}
        lactosa={lactosa}
        setLactosa={setLactosa}
        azucar={azucar}
        setAzucar={setAzucar}
        alcohol={alcohol}
        setAlcohol={setAlcohol}
        vegetariano={vegetariano}
        setVegetariano={setVegetariano}
        picante={picante}
        setPicante={setPicante}
      />
    </>
  );
};

export default AdvanceInfoSection;